import { Injectable } from "@angular/core";

import { MapperInterface } from "../mapper-inteface";

import { MetadatiProtocolloGescorDTO } from "@app/shared/dto/gescor/metadati-protocollo-gescorDTO";

import { MetadatiProtocolloGescorVO } from "@app/shared/vo/gescor/metadati-protocollo-gescorVO";

@Injectable({
  providedIn: "root"
})
export class MapperMetaDatiProtocolloGescor
  implements
    MapperInterface<MetadatiProtocolloGescorDTO, MetadatiProtocolloGescorVO> {
  convertVoToDto(t: MetadatiProtocolloGescorVO): MetadatiProtocolloGescorDTO {
    const metadatiProtocolloDTO = new MetadatiProtocolloGescorDTO();
    metadatiProtocolloDTO.anno = t.anno;
    metadatiProtocolloDTO.data = t.data;
    metadatiProtocolloDTO.numero = t.numero;
    metadatiProtocolloDTO.tipo = t.tipo;

    return metadatiProtocolloDTO || new MetadatiProtocolloGescorDTO();
  }

  convertDtoToVo(t: MetadatiProtocolloGescorDTO): MetadatiProtocolloGescorVO {
    const metadatiProtocolloVO = new MetadatiProtocolloGescorVO();
    if (t != null) {
      metadatiProtocolloVO.anno = t.anno;
      metadatiProtocolloVO.data = t.data;
      metadatiProtocolloVO.numero = t.numero;

      switch (t.tipo) {
        case "ARRIVO_CARTACEO":
          metadatiProtocolloVO.tipo = "Arrivo cartaceo";
          metadatiProtocolloVO.tipoAbbreviato = "AC";
          break;
        case "ARRIVO_DIGITALE":
          metadatiProtocolloVO.tipo = "Arrivo digitale";
          metadatiProtocolloVO.tipoAbbreviato = "AD";
          break;
        case "PARTENZA_CARTACEO":
          metadatiProtocolloVO.tipo = "Partenza cartaceo";
          metadatiProtocolloVO.tipoAbbreviato = "PC";
          break;
        case "PARTENZA_DIGITALE":
          metadatiProtocolloVO.tipo = "Partenza digitale";
          metadatiProtocolloVO.tipoAbbreviato = "PD";
          break;
        case "INTERNO_DIGITALE":
          metadatiProtocolloVO.tipo = "Interno digitale";
          metadatiProtocolloVO.tipoAbbreviato = "ID";
          break;
        case "INTERNO_CARTACEO":
          metadatiProtocolloVO.tipo = "Interno cartaceo";
          metadatiProtocolloVO.tipoAbbreviato = "IC";
          break;
      }
    }
    return metadatiProtocolloVO || new MetadatiProtocolloGescorVO();
  }
  convertListVoToDto(
    e: MetadatiProtocolloGescorVO[]
  ): MetadatiProtocolloGescorDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: MetadatiProtocolloGescorDTO[]
  ): MetadatiProtocolloGescorVO[] {
    throw new Error("Method not implemented.");
  }
}
